import { render, staticRenderFns } from "./employee-single.vue?vue&type=template&id=71d8c08e&scoped=true&"
import script from "./employee-single.vue?vue&type=script&lang=js&"
export * from "./employee-single.vue?vue&type=script&lang=js&"
import style0 from "../../component/public/css/table.scss?vue&type=style&index=0&id=71d8c08e&prod&lang=scss&scoped=true&"
import style1 from "./employee-single.vue?vue&type=style&index=1&id=71d8c08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8c08e",
  null
  
)

export default component.exports